import Image from "next/image"

import logo from "@/../public/logo.png"

export default function IconLogo({ ...props }: Omit<React.ComponentProps<typeof Image>, "src" | "alt">) {
  return <Image {...props} src={logo} alt="Spectra Logo" unoptimized quality={100} />
}
